import { motion } from "framer-motion";
import SceneShell from "../components/SceneShell";
import CastleGraphic from "../components/CastleGraphic";

/**
 * Scene 53 — Closing punch · "Together… that's very hard to compete with."
 * Full castle + warriors + moat with ambient gold aura.
 */

export default function Scene53_HardToCompete() {
  return (
    <SceneShell variant="ink" align="center" data-testid="scene-hard-to-compete">
      <motion.div
        className="absolute inset-0 pointer-events-none"
        animate={{
          background: [
            "radial-gradient(ellipse at 50% 55%, rgba(233,168,32,0.20) 0%, transparent 60%)",
            "radial-gradient(ellipse at 50% 55%, rgba(233,168,32,0.36) 0%, transparent 60%)",
            "radial-gradient(ellipse at 50% 55%, rgba(233,168,32,0.20) 0%, transparent 60%)",
          ],
        }}
        transition={{ duration: 5.5, repeat: Infinity, ease: "easeInOut" }}
      />

      <div className="relative w-full h-full flex flex-col">
        {/* Castle (full layer with glow) */}
        <motion.div
          initial={{ opacity: 0.6, scale: 0.96 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.4, ease: [0.16, 1, 0.3, 1] }}
          className="flex-1 mt-2 mx-auto w-full max-w-[1500px] relative"
          data-testid="hard-to-compete-castle"
        >
          <CastleGraphic layer={3} glow moatTone="gold" />

          {/* Three small floating tags as a recap legend */}
          <motion.div
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 1.4 }}
            className="absolute top-[3%] left-[4%] flex flex-col gap-2 z-10"
          >
            <Pill color="#e9a820" label="Castle" sub="Core services" />
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 1.6 }}
            className="absolute top-[3%] right-[4%] flex flex-col gap-2 z-10"
          >
            <Pill color="#96C11F" label="Archers + Knights" sub="Social Go + Pro" />
          </motion.div>
          {/* Social Week pill — moved from bottom to top-centre */}
          <motion.div
            initial={{ opacity: 0, y: -14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 1.8 }}
            className="absolute top-[3%] left-1/2 -translate-x-1/2 flex flex-col gap-2 z-10"
          >
            <Pill color="#e9a820" label="Moat" sub="Social Week" />
          </motion.div>
        </motion.div>
      </div>
    </SceneShell>
  );
}

function Pill({ color, label, sub }) {
  return (
    <div
      className="rounded-full px-4 py-2 backdrop-blur-md"
      style={{
        background: "rgba(0,0,0,0.55)",
        border: `1px solid ${color}66`,
        boxShadow: `0 0 30px ${color}33`,
      }}
    >
      <div
        className="text-[9px] tracking-[0.28em] uppercase"
        style={{ color }}
      >
        {label}
      </div>
      <div
        className="text-sm"
        style={{ color: "rgba(255,255,255,0.92)", fontWeight: 600 }}
      >
        {sub}
      </div>
    </div>
  );
}
